export const INCREMENT_BLOCK_COUNTER = 'INCREMENT_BLOCK_COUNTER'
export const DECREMENT_BLOCK_COUNTER = 'DECREMENT_BLOCK_COUNTER'
export const ENABLE_UI_BLOCK = 'ENABLE_UI_BLOCK'
export const DISABLE_UI_BLOCK = 'DISABLE_UI_BLOCK'



// WEBPACK FOOTER //
// ./src/Reducers/UIBlock/const.js